import { EditableFormatSummary } from "../../../domain/editableFormat";
import { StringFilterParameter, RegExpFilterParameter } from "../../../../base/components/system/filters";

export class EditableFormatSummaryFilterParameter {
  constructor(
    name: string = "",
    masterCode: RegExp = null,
    documentKindId: string = "",
    tag: string = "",
    containsExpired: boolean = false,
    containsDeleted: boolean = false) {
    this.name = new StringFilterParameter(name, true, [" ", "　"]);
    this.masterCode = new RegExpFilterParameter(masterCode);
    this.documentKind = new StringFilterParameter(documentKindId, false);
    this.tag = new StringFilterParameter(tag);
    this.containsExpired = containsExpired; // TODO フィルタのUIにより見直しが必要
    this.containsDeleted = containsDeleted; // TODO フィルタのUIにより見直しが必要 
  }

  name: StringFilterParameter;
  masterCode: RegExpFilterParameter;
  documentKind: StringFilterParameter;
  tag: StringFilterParameter;
  containsExpired: boolean;
  containsDeleted: boolean;

  filter(source: EditableFormatSummary): boolean {
    return this.name.filter(source.name)
      && this.masterCode.filter(source.masterCode
        ? source.masterCode
        : "")
      && this.documentKind.filter(source.reportTypeId !== null && source.reportTypeId !== undefined
        ? source.reportTypeId.toString()
        : "")
      && this.tag.filter(source.tag
        ? source.tag
        : "")
      // && (this.containsExpired
      //   ? true
      //   : !source.expired)
      && (this.containsDeleted
        ? true
        : !source.deleted);
  }

  clone(): EditableFormatSummaryFilterParameter {
    return new EditableFormatSummaryFilterParameter(
      this.name.keyword,
      this.masterCode.regExp,
      this.documentKind.keyword,
      this.tag.keyword,
      this.containsExpired,
      this.containsDeleted
    );
  }
}
